module.exports = __webpack_public_path__ + "static/media/helphone.4ed57825.svg";